/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_CreateResumeEmailKnownStates {
    EmailFoundOnApplicant = 10,
    EmailFoundOnPublicUser = 30,
    EmailFoundOnDEKOUser = 31,
    EmailFoundInNAV = 40,
    PhoneNumberFoundOnApplicant = 50,
    PhoneNumberFoundOnTemp = 60,
    PhoneNumberFoundInNAV = 70,
    EmailFoundOnTempStatePlaceholder = 80,
    PhoneNumberFoundOnTempStatePlaceholder = 90,
    EmailFoundOnCustomerContactPerson = 100,
    UnknownPhoneNumber = -2,
    UnknownEmail = -1,
}
